/**
 * Route for `recurring-commission-saas-model`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RecurringCommissionSaasModelPage } from "../features/recurring-commission-saas-model/RecurringCommissionSaasModelPage";

export const recurringCommissionSaasModelRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/recurring-commission-saas-model",
	component: RecurringCommissionSaasModelPage,
});

export default recurringCommissionSaasModelRoute;
